// @flow
import React from 'react';
import {
  Banner,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { Grid } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import { AlertCriticalIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import useIntl from '../../hooks/useIntl';
import { useMissingChargesNotice } from './hooks';
import messages from './messages';

const MissingChargesNotice = () => {
  const { formatMessage } = useIntl();
  const { count, charges, acknowledge } = useMissingChargesNotice();

  // No onClose so Escape and backdrop clicks are ignored: acknowledging is
  // the only way out.
  return (
    <Modal
      open={count > 0}
      title={formatMessage(messages.title)}
      icon={<AlertCriticalIcon />}
      status={'error'}
      noCloseIcon
      actionsProps={[
        {
          children: formatMessage(messages.gotIt),
          onClick: acknowledge,
          'data-testid': 'missing-charges-notice-ok',
        },
      ]}
      ContentProps={{
        sx: {
          width: {
            xs: 'calc(100% - 32px)',
            sm: 600,
          },
        },
      }}
    >
      <Grid container spacing={2} mb={1}>
        <Grid item xs={12}>
          <Typography>
            {formatMessage(messages.notCreated, {
              count,
              charges,
              b: (chunks) => <b>{chunks}</b>,
            })}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant={'labelLarge'} display={'block'}>
            {formatMessage(messages.addManually, { count })}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Banner
            status={'error'}
            title={formatMessage(messages.notifyAdministrator)}
            message={formatMessage(messages.missedForOtherHouseholds, {
              count,
            })}
            sx={{ width: '100%' }}
          />
        </Grid>
      </Grid>
    </Modal>
  );
};

export default MissingChargesNotice;
